export default [
  {
    path: '/partyConstruction',
    name: 'partyConstruction',
    component: () => import('@/views/party-construction/index.vue'),
    meta: {
      title: '党建工作',
    },
  },
  {
    path: '/partyConstruction/detail',
    name: 'partyConstruction-detail',
    component: () => import('@/views/party-construction/detail.vue'),
    meta: {
      title: '党建工作',
      hiddenCarousel: true,
    },
  },
];

